import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { goPopup } from 'Store/actions/portalModalActions';
import { nullSafe } from 'Utility/globalMethods';
import { getTransactions } from 'Store/selectors';
import * as actionLayer from '../../modules/TransactionsActions';
import ReverseTransactionAmountModal from './ReverseTransactionAmountModal';

const mapDispatchToProps = (dispatch) => ({
	closeModal: () => dispatch(goPopup('')),
  setReverseAmount: (value) => dispatch(actionLayer.fetchReversing.request({...value})),
	...bindActionCreators(actionLayer, dispatch),
});

const mapStateToProps = (state) => ({
	transactionItem: nullSafe(() => getTransactions(state, 'manageItem'), []),
});

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps) => ({
	...stateProps,
	actions: dispatchProps,
}))(ReverseTransactionAmountModal);
